// Shared API base — used by all extracted components.
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
